module.exports = __webpack_public_path__ + "img/1-off.0f9e3427.png";